import Animated from "react-native-reanimated";
import { View } from "tamagui";

/** Tamagui View wrapped with Reanimated, which preserves Tamagui props while accepting animated styles */
const AnimatedView = Animated.createAnimatedComponent(View);

export default AnimatedView;
